module.exports = __webpack_public_path__ + "static/village_bn-3405c86c1da6ccda20d1fafdd3bd32ac.png";